import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswAlertsState {
}

export default {
  state : {},
  actions: {
    getAll(context: ActionContext<MswAlertsState, RootStoreState>) { // tslint:disable-line
      context.commit('startLoading', null, { root: true });
      const url = 'notification/get-all';
      return ApiServiceWrapper.get(url);
    },
    getUserDetails(context: ActionContext<MswAlertsState, RootStoreState>, userId : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/get-user-details?username=${userId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getEmailSubscription(context: ActionContext<MswAlertsState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-email-subscriptions';
      return ApiServiceWrapper.get(endpoint);
    },
    getVulNotification(context: ActionContext<MswAlertsState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-vulnotification';
      return ApiServiceWrapper.get(endpoint);
    },
    updateNotificationPrefs(context: ActionContext<MswAlertsState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/update-notification-pref';
      return ApiServiceWrapper.post(endpoint, request);
    },
    updateEmailPreference(context: ActionContext<MswAlertsState, RootStoreState>, request: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/save-email-subscriptions';
      return ApiServiceWrapper.post(endpoint, request);
    },
  },
  namespaced: true,
} as Module<MswAlertsState, RootStoreState>;
